import { MantineTheme, rem } from "@mantine/styles";

import { ThemeComponent } from "./helpers.ts";
import inputWrapperTheme, {
  defaultInputWrapper as inputWrapper,
} from "./input.ts";

const defaultInputWrapper = (theme: MantineTheme) => ({
  ...inputWrapper(theme),
  visibilityToggle: {
    backgroundColor: "transparent!important",
  },
  input: {
    border: "none!important",
  },
});

export default function passwordInputWrapperTheme(): ThemeComponent {
  const inputTheme = inputWrapperTheme();

  return {
    ...inputTheme,
    styles: (theme) => defaultInputWrapper(theme),
    sizes: {
      s: () => ({
        ...inputTheme.sizes?.s,
        innerInput: {
          padding: `0 ${rem(4)} 0 ${rem(12)}`,
        },
      }),
      m: () => ({
        ...inputTheme.sizes?.m,
        innerInput: {
          padding: `0 ${rem(12)}`,
        },
      }),
    },
  };
}
